import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgSearchHome = (props) => (
  <SvgIcon {...props} title="SearchHome">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.05 1.42c-7.567.92-11.262 9.59-6.675 15.663 3.235 4.283 9.697 5.084 13.828 1.714l.262-.215 2.925 2.927c1.068 1.016.99.967 1.068 1.016.465.292 1.094.031 1.178-.489 0-.323 0-.413-1.035-1.519-1.648-1.65-2.997-3.018-2.997-3.04 0-.022.083-.14.184-.26 1.86-2.221 2.57-5.65 1.785-8.61-1.229-4.629-5.812-7.76-10.524-7.186Zm2.213 1.566c6 .853 9.07 7.686 5.709 12.704-3.518 5.25-11.365 4.757-14.18-.891-2.943-5.905 1.957-12.74 8.47-11.813Z"
        fill="#017163"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.688 6.063c-.39.204-4.565 3.766-4.639 3.958-.217.57.321 1.146.896.956.127-.041 2.722-2.146 3.986-3.23.063-.055.297.125 2.024 1.563 2.036 1.695 2.12 1.754 2.446 1.693.49-.091.762-.703.494-1.111-.104-.159-4.421-3.756-4.6-3.833-.187-.08-.448-.078-.607.004Zm-2.856 5.695c-.421.227-.43.273-.414 2.157.02 2.312-.4 2.063 3.507 2.08 3.36.014 3.268.022 3.507-.291l.121-.16v-1.701c0-1.889.013-1.8-.306-2.039-.184-.137-.62-.13-.823.015-.29.207-.315.334-.316 1.595l-.001 1.123H8.882l-.013-1.198c-.015-1.317-.012-1.306-.315-1.531-.16-.12-.545-.146-.722-.05Z"
        fill="#017163"
      />
    </svg>
  </SvgIcon>
);

export default SvgSearchHome;
